<template>
  <div
    class="tool-preview"
    :id="point.ArticleNr"
    :class="[point.IsMarathon ? 'marathon' : '',
    point.Disabled ? 'disabled' : '',
    point.Selected ? 'selected' : '']"
    v-on:click="togglePoint(point)"
    :style="{ order: index }"
  >
    <div class="tool-preview__image">
      <img
        :src="point.ImageThumbnail"
        :alt="point.ImageAlt"
      />
    </div>
    <div class="tool-preview__name">
      <div class="part-Name"><span
          class="icon-Marathon"
          v-if="point.IsMarathon"
        ></span>{{ point.Name }}</div>
    </div>
    <div class="tool-preview__properties">
      <div>
        <span :class="[activeConfiguratorDepthIcon, 'tool-property']"></span>
        <p>{{ point.Range }}</p>
      </div>
      <div v-if="point.Width">
        <span :class="[activeConfiguratorSizeIcon, 'tool-property']"></span>
        <p>{{ point.Width }}</p>
      </div>
      <div
        v-for="category in point.Categories"
        v-bind:key="category.Id"
      >
        <span
          class="tool-property"
          :class="category.IconClass"
        ></span>
        <p>{{ category.Name }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getActiveConfiguratorDepthIconClass, getActiveConfiguratorSizeIconClass} from '../helpers/configuratorHelper';

const props = defineProps({
  point: Object,
  index: Number
});

const activeConfiguratorDepthIcon = getActiveConfiguratorDepthIconClass();
const activeConfiguratorSizeIcon = getActiveConfiguratorSizeIconClass();

const emit = defineEmits([
  'togglePoint'
]);

function togglePoint(point) {
  emit('togglePoint', point);
}
</script>